import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import exportIcon from "../../static/assets/Exporter.svg";

const exportMenuIcon = (
  <img
    src={exportIcon}
    alt=""
    className="char-button-icon"
    style={{ filter: "brightness(0) invert(0.45)" }}
  />
);

export const getPageHeaderExportMenuItems = (items = []) =>
  items.map((item) => ({
    key: item.key,
    label: item.label,
    onClick: item.onClick,
    icon: item.menuIcon ?? item.icon ?? exportMenuIcon,
  }));

const PageHeaderExportButton = ({ disabled = false, items = [], label }) => {
  const { t } = useTranslation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const buttonLabel = label ?? t("Export");

  const canExport = !disabled && items.length > 0;

  useEffect(() => {
    if (!canExport) {
      setIsDropdownOpen(false);
    }
  }, [canExport]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isDropdownOpen]);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => canExport && setIsDropdownOpen(!isDropdownOpen)}
        className="char-button char-button-primary"
        disabled={!canExport}
      >
        <img
          src={exportIcon}
          alt=""
          className="char-button-icon char-button-icon--inverted"
        />
        <span>{buttonLabel}</span>
        <i className="fas fa-chevron-down char-button-chevron" aria-hidden />
      </button>
      {isDropdownOpen && (
        <div className="char-dropdown">
          {items.map((item) => (
            <button
              key={item.key || item.label}
              type="button"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                item.onClick?.(e);
                setIsDropdownOpen(false);
              }}
              className="char-dropdown-item"
            >
              {item.icon ?? (
                <img
                  src={exportIcon}
                  alt=""
                  className="char-dropdown-item-icon"
                />
              )}
              <span>{item.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default PageHeaderExportButton;
